import React, { useEffect, useState } from 'react'

import { observer } from 'mobx-react-lite'

import _ from 'lodash'
import { $auth } from 'ziphy-web-shared/basic/entities/auth'
import { $patients } from 'ziphy-web-shared/basic/entities/patients'
import { WithLoaderWrapper } from 'ziphy-web-shared/basic/lib/loaders'
import { useLoaderSubscribe } from 'ziphy-web-shared/basic/utils'

import { $liveqBooking } from '@store'

import { routeActions } from '@config/routeActions'

import { bookingSchema } from '../../config/bookingSchema'
import { useLoader } from 'ziphy-web-shared/basic/hooks'
import { useParams } from 'react-router-dom'
import { $router } from 'ziphy-web-shared/basic/utils/router'


const withSurveyDataInit = (WrappedComponent) => {
  const withSurveyDataInit = ({ ...props }) => {
    const { serviceId, regionId } = useParams()

    const {isLoading} = useLoader(async () => {
      await $liveqBooking.start({
        instance_sid: `livequeue_client_service_${serviceId}`,
        params: {
          region_id: parseInt(regionId)
        }
      })

      if ($liveqBooking.token) {
        $router.executeAutoTarget({to: `/explore/anonym/${$liveqBooking.survey._id}/${$liveqBooking.token}`}, { type: 'replace' })
      }
      else {
        $router.executeAutoTarget({to: `/explore/survey/${$liveqBooking.survey._id}`}, { type: 'replace' })
      }
    })

    // TODO uncomment when url upload will be ready
    // const searchParams = useRouterSearchParams('replace')
    // useEffect(() => {
    //   searchParams.set($booking.searchParams)
    // }, [$booking.searchParams])

    return (
      <WithLoaderWrapper
        isLoading={isLoading}
        loaderMode={props.loaderMode ? props.loaderMode : 'pageWrapper'}
        withWrapper={false}
      >
        <WrappedComponent {...props} />
      </WithLoaderWrapper>
    )
  }

  withSurveyDataInit.displayName = `withSurveyDataInit(${WrappedComponent.displayName || WrappedComponent.name})`

  return observer(withSurveyDataInit)
}

export default withSurveyDataInit
